import {
  Box,
  Button,
  Card,
  Collapse,
  Divider,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Typography,
} from "@mui/material";
import { colors } from "../../constants/colors";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import React, { useCallback, useEffect, useState } from "react";
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { cdnUrl } from "../../config";
import { useSelector } from "react-redux";

export const Topics = ({ topics, setDisplayContent, activeTopbar, setTopicIndex, setSubTopicIndex, topicIndex, subTopicIndex }) => {

  const { topic, theme, mode } = useSelector(state => ({
    topic: state.teachingPanel.topic,
    theme: state.theme.theme,
    mode: state.theme.mode,
  }));

  const data = useSelector((state) => state.teachingPanel); 

  const [activeTopic, setActiveTopic] = useState(topic?.Topic);
  const [activeSubTopic, setActiveSubTopic] = useState(topic?.SubTopic);
  const [isExpand, setExpand] = useState(false);

  useEffect(() => {
    if(topic) {
      
      setActiveTopic(topic?.Topic);
      setActiveSubTopic(topic?.SubTopic);
    }
  }, [topic]);

  useEffect(() => {
    
    if(topics) {
      setActiveTopic(topics[topicIndex].Topic);
      setActiveSubTopic(topics[topicIndex].subtopics[subTopicIndex].SubTopic);
    }
  }, [topicIndex, subTopicIndex]);
 
  const changeActiveSubTopic = useCallback((topic, index, subTopicIndex, subtopicName) => {
    if(Object.keys(topic).length > 0) {
      
      setTopicIndex(index);
      setSubTopicIndex(subTopicIndex)
      setActiveSubTopic(subtopicName);
      setDisplayContent(topic, subTopicIndex);
    }
  }, [setDisplayContent, setSubTopicIndex,setTopicIndex]);


  const handleOpenSubTopics = useCallback((topic, topicName) => {
    const value = topicName;
    if (value) {
      if(value === activeTopic) {
        setActiveTopic("");
      } else {
        setActiveTopic(value);
      }
      
    }
  }, [activeTopic]);

  const handleExpand = useCallback(() => {
    setExpand(!isExpand);
  }, [isExpand]);

  return (
    <>
    {activeTopbar === "Topic" && data?.topics?.length > 0 &&
      <Card
        sx={{
          p: 2,
          boxShadow: "0px 4px 4px 4px #0000000D",
          borderRadius: '20px',
          background: mode === "dark" && colors.darkModeCardBackground,
          
        }}
      >
        <Typography
          variant="h6"
          color={mode === "dark" ? colors.white : colors.darkGreyFont}
          textAlign={"start"}
          display={'flex'}
          justifyContent={'space-between'}
          mb={2}
        >
          Topics
          <Button onClick={handleExpand}
            endIcon={isExpand ? <UnfoldLessIcon /> : <UnfoldMoreIcon /> }
            variant="outlined"
            sx={{ color: mode === "dark" ? colors.white : theme.fontColor, borderColor: theme.color }}
          >
            <span>{isExpand ? "Expand less" : "Expand more" }</span>
          </Button>
        </Typography>
        <Box sx={{ maxHeight: "750px", overflowY: "scroll" }}>
          {topics ? topics?.map((topic, index) => (
            <TopicList key={index} topic={topic} index={index} activeTopic={activeTopic} setActiveTopic={setActiveTopic} activeSubTopic={activeSubTopic} handleOpenSubTopics={handleOpenSubTopics} changeActiveSubTopic={changeActiveSubTopic}  topicIndex={topicIndex} subTopicIndex={subTopicIndex} isExpand={isExpand} setExpand={setExpand} />
          )) : 
          
          <>
            <Skeleton animation="wave" variant="rectangular" sx={{ width: '100%', height: '50px', borderRadius: '10px', mb: 2, background: mode === "dark" ? colors.darkModeCardBackground : '#F1F4FA' }} />
            <Skeleton animation="wave" variant="rectangular" sx={{ width: '100%', height: '50px', borderRadius: '10px', mb: 2, background: mode === "dark" ? colors.darkModeCardBackground : '#F1F4FA' }} />
            <Skeleton animation="wave" variant="rectangular" sx={{ width: '100%', height: '50px', borderRadius: '10px', mb: 2, background: mode === "dark" ? colors.darkModeCardBackground : '#F1F4FA' }} />
          </> }
        </Box>
        
      </Card> }
    </>
  );
};

const TopicList = React.memo(({ topic,activeTopic, setActiveTopic, activeSubTopic, handleOpenSubTopics, changeActiveSubTopic, index, topicIndex, subTopicIndex, isExpand, setExpand  }) => {

  const { mode } = useSelector((state) => state.theme);

  const [open, setOpen] = useState(false);

  const handleOpen = useCallback((topic) => {
    if(isExpand) {
      setExpand(!isExpand);
    }
    handleOpenSubTopics(topic, topic.Topic)
  }, [isExpand, setExpand, handleOpenSubTopics]);

  return (
    <>
      <style>
        {`
          @media (min-width: 1200px) and (max-width: 1300px) {
            .subtopic-listitem {
              flex-direction: column;
              align-items: start;
            }
          }
        `}
      </style>
      <ListItemButton
        onClick={() => handleOpen(topic)}
        sx={{
          background: mode === "dark" ? ( activeTopic === topic.Topic ? colors.darkModeBackground : colors.darkModeCardBackground ) : activeTopic === topic.Topic ? "#F1F4FA" : "#FFFFFF",
          // background: mode === "dark" && colors.darkModeCardBackground,
          borderRadius: '10px', p: '10px',
          color: mode === "dark" ? colors.white : colors.darkGreyFont
        }}
        data-value={topic.Topic}
      >
        <ListItemText sx={{ color: colors.darkGreyFont, fontWeight: "bold" }}>
          <Typography sx={{ color: mode === "dark" ? colors.white : colors.darkGreyFont, fontSize: '18px' }}>
            {topic.Topic}
          </Typography>
          
        </ListItemText>
        <span style={{ marginRight: '5px', background: 'orange', padding: '3px 8px', borderRadius: '50%', color: 'black', fontSize: '16px', fontWeight: 'bold' }}>{topic?.subtopics.length}</span>

        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Divider />
      <Collapse in={( activeTopic === topic.Topic || isExpand) ? true : false} timeout="auto" unmountOnExit>
        {(activeTopic === topic.Topic || isExpand) && topic.subtopics.map((subtopic, subTopicIndex) => {
          
          
          return (
          <ListItemButton
            className="subtopic-listitem"
            key={subTopicIndex}
            data-value={subtopic?.SubTopic}
            onClick={() => changeActiveSubTopic(topic, index, subTopicIndex, subtopic.SubTopic)}
            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', gap: '10px', borderRadius: '10px', marginBottom: '20px' }}
          >
            <ListItemIcon>
              <Box sx={{  }}>
                <img loading="lazy" src={`${cdnUrl}/Images/StudentPortal/VideoThumbNail/${subtopic.Thumbnail}`} alt=" " style={{ width: '100%', height: '100%', maxHeight: '250px', borderRadius: '5px' }} />
                {/* <AutoStoriesIcon sx={{ p: 1 }} /> */}
              </Box>
            </ListItemIcon>
            <ListItemText>
              <Typography
                sx={{
                  fontWeight:
                  activeSubTopic === subtopic.SubTopic ? "bold" : "normal",
                  color: mode === "dark" ? colors.white : colors.darkGreyFont,
                }}
              >
                {subtopic.SubTopic}
              </Typography>
            </ListItemText>
          </ListItemButton>
          )
        })}
      </Collapse>
    </>
  );
});
